import { ModelBase } from 'store/model-base';

export class CmsLevelMoveSuccess extends ModelBase {
    public static storeName: string = 'cmsLevelMoveSuccess';

    public success: SuccessContent;
    public billPreviewSuccess: SuccessContent;


}
